import { JobNotesResponse } from '@shared/api/truktApi';
import { OrderNoteGetResponse } from '@trukt/tms-api/NoteService';
import { InfiniteData } from '@tanstack/react-query';
import { CreateNoteMutateFunction } from './hooks';

export enum NoteObjectType {
  JOB = 'job',
  ORDER = 'order',
}

export interface CardInternalNotesProps {
  orderGuid: string;
  jobGuid?: string;
  queryInfo: {
    isFetching: boolean;
    isLoading: boolean;
    isFetchingNextPage: boolean;
    fetchNextPage(): void;
  };
  activeIndex: {
    value: number;
    setValue(index: number): void;
  };
  notes: InfiniteData<JobNotesResponse | OrderNoteGetResponse> | undefined;
  onSubmit(value: CreateNoteMutateFunction): void;
  isSubmitting: boolean;
  stats?: {
    client: { total: string };
    lead: { total: string };
    update: { total: string };
  };
}
